exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination{list-style-type:none}.pagination-item{display:inline-block}.active{background-color:#4aae9b;color:#fff}", ""]);

// exports
